import React, { Fragment } from "react";
import { ReactSVG } from "react-svg";

import { formatDate } from "../../services/date";

import addIcon from "../../assets/icons/add.svg";
import equalIcon from "../../assets/icons/equal.svg";

const KpiComposition = ({ steps, result }) => (
  <div className="kpi-composition">
    {steps?.map((step, index) => (
      <Fragment key={index}>
        <div className="step" style={{ backgroundColor: step?.background }}>
          <div className="value">
            {parseFloat(step.value).toFixed(step?.precision || 3)}
            {step.weight && (
              <Fragment>
                <span className="multiply">*</span>
                {parseFloat(step.weight).toFixed(2)}
              </Fragment>
            )}
          </div>
          {step.date && (<span className="date">{formatDate(step.date)}</span>)}
        </div>
        {index < (steps.length - 1) && (
          <ReactSVG className="icon" src={addIcon} />
        )}
      </Fragment>
    ))}
    <ReactSVG className="icon" src={equalIcon} />
    <div className="step result">{parseFloat(result).toFixed(3)}</div>
  </div>
);

export default KpiComposition;
